import React from "react";
import { useSelector } from "react-redux";
import './_box3612.scss'
import { ReactComponent as Icon3 } from "../../../assets/new-icons/ricarica3Icon.svg";
import { ReactComponent as Icon6 } from "../../../assets/new-icons/ricarica6Icon.svg";
import { ReactComponent as Icon12 } from "../../../assets/new-icons/ricarica12Icon.svg";

function Box3612Home() {
    const nomePrenotazione = useSelector(
        (user) => user.user.nomePrenotazione3612
    );

    const switchIcon = () => {
        switch (nomePrenotazione) {
            case 'Ricarica 3':
                return <Icon3 />;
            case 'Ricarica 6':
                return <Icon6 />;
            default:
                return <Icon12 />;
        }
    }
    const switchDescription = () => {
        switch (nomePrenotazione) {
            case 'Ricarica 3':
                return "Abbiamo caricato sul tuo conto una media di 3 mesi. Fino all'esaurimento della ricarica pagherai il prezzo migliore.";
            case 'Ricarica 6':
                return "Abbiamo caricato sul tuo conto una media di 6 mesi. Fino all'esaurimento della ricarica pagherai il prezzo migliore.";
            default:
                return "Abbiamo caricato sul tuo conto una media di 12 mesi. Fino all'esaurimento della ricarica pagherai il prezzo migliore.";
        }
    }
  return (
    <div className="box3612Home boxInfo">
        <div className="item">
            <div className="item-top">
                <div className="item-top_icon">
                    {switchIcon()}
                </div>
                <div className="item-top_text">
                <p className="main">{nomePrenotazione && nomePrenotazione} </p>
                </div>
            </div>
            <div className="item-bottom">
                <div className="item-bottom_box">
                    <p className="label">{switchDescription()}</p>
                </div>
            </div>
        </div>
    </div>
  );
}

export default Box3612Home;
